module.exports = __webpack_public_path__ + "img/amazon_and_wahool.464380b8.png";